import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { isEmpty, keyBy } from 'lodash';
import VerbButton, { VERB_BUTTON_TYPE } from '../../../../../shared/components/VerbButton';
import VerbSelect from '../../../../../shared/components/formComponents/inputs/VerbSelect';
import VerbTable from '../../../../../shared/components/VerbTable';

export default class DimensionAbilitiesTable extends Component {
    static propTypes = {
        changeFormValue: PropTypes.func,

        abilitiesById: PropTypes.object,
        currentValues: PropTypes.object
    };

    constructor(props) {
        super(props);
        this.state = {
            abilitiesToAdd: []
        };
    }

    _getAbilitiesOptions = () => {
        const abilitiesOptions = [];
        const { abilitiesById = {}, currentValues = {} } = this.props;
        const existingabilitiesById = keyBy(currentValues.abilityIds || []);
        Object.values(abilitiesById).forEach((ability) => {
            if (!existingabilitiesById[ability._id]) {
                abilitiesOptions.push({
                    value: ability._id,
                    label: ability.name
                });
            }
        });

        return abilitiesOptions;
    };

    _addAbility = (newValues) => this.setState({ abilitiesToAdd: newValues });

    addAbilitiesToDimension = () => {
        const { currentValues, changeFormValue } = this.props;
        if (!isEmpty(this.state.abilitiesToAdd)) {
            changeFormValue({
                field: 'abilityIds',
                value: [
                    ...(currentValues.abilityIds || []),
                    ...this.state.abilitiesToAdd.map((ability) => ability.value)
                ]
            });
        }
    };

    removeAbilityFromDimension = (abilityIdToRemove) => {
        const { currentValues, changeFormValue } = this.props;
        const newAbilityIds = currentValues.abilityIds.filter((abilityId) => abilityId !== abilityIdToRemove);
        this.setState({ abilitiesToAdd: [] });
        changeFormValue({
            field: 'abilityIds',
            value: newAbilityIds
        });
    };

    _renderAbilityIdsTable = () => {
        const { currentValues, abilitiesById } = this.props;
        return (currentValues.abilityIds || []).map((abilityId) => {
            const { name } = abilitiesById[abilityId] || {};
            return (
                <tr key={abilityId} className={'ability-row'}>
                    <td className={'buttonCell'}>
                        <VerbButton
                            buttonType={VERB_BUTTON_TYPE.SECONDARY_DETAILS}
                            fontAwesomeIcon={'fa-trash-alt'}
                            onClick={() => {
                                this.removeAbilityFromDimension(abilityId);
                            }}
                        />
                    </td>
                    <td>{name}</td>
                </tr>
            );
        });
    };

    render() {
        const abilitesTableHead = (
            <thead>
                <tr>
                    <th className={'buttonCell'}>Actions</th>
                    <th>Ability Name</th>
                </tr>
            </thead>
        );
        return (
            <div className={'dimension-abilities-table'}>
                <div>
                    <label className={'framework-table-header col-12'}>Add Abilities</label>
                </div>
                <div className={'row'}>
                    <VerbSelect
                        styleProps={'col-9'}
                        value={this.state.abilitiesToAdd}
                        options={this._getAbilitiesOptions()}
                        onChange={this._addAbility}
                        isMulti={true}
                    />
                    <div className={'col-3 form-action-buttons formButtons'}>
                        <VerbButton
                            buttonType={VERB_BUTTON_TYPE.PRIMARY_DEFAULT}
                            onClick={this.addAbilitiesToDimension}
                            fontAwesomeIcon={'fal fa-layer-group'}
                            disabled={!this.state.abilitiesToAdd.length}
                            buttonText={'ADD ABILITIES'}
                        />
                    </div>
                </div>
                <VerbTable striped={false} bordered={false} hover={true} headerComponent={abilitesTableHead}>
                    <tbody>{this._renderAbilityIdsTable()}</tbody>
                </VerbTable>
            </div>
        );
    }
}
